import { Outlet, useNavigate } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'

import { useModuleAvailability } from 'modules/core/hooks/useModuleAvailability'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import hasFeature from 'modules/core/lib/hasFeature'

import WorkAreasPage from 'modules/locations/pages/settings/WorkAreas'

const ProtectedWorkAreasPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { moduleAvailability } = useModuleAvailability(AvailableModules.space_control)
  const spacesEnabled = moduleAvailability.available

  if (!hasFeature('dev_location_work_areas') && !spacesEnabled) {
    navigate(navigation.settings.locations.fullPath())

    return null
  }

  return (
    <WorkAreasPage>
      <Outlet />
    </WorkAreasPage>
  )
}

export default ProtectedWorkAreasPage
